export default __webpack_public_path__ + "static/home6-e3615a5c1d4d332b85bde1cd0f9b0e73.jpg";